import {
  ActionAddNewMiner,
  ActionAddNewMinerList,
  ActionBaseStoredMiners,
  ActionDeleteMiner,
  ActionRefreshMiner,
  ActionSetMiners,
  ActionTypesStoredMiners,
} from "./actionTypes";
import { TabsTotals } from "@components/Pagination/Pagination.props";
import { Tab, tabIDToType } from "@store/minersSelect/actionTypes";
import { IUnknownMiner } from "@utils/hooks/useGetMinerList";
import { fromEntries } from "@utils/entries";
import { MinerTabsNames } from "@services/http/responses/BaseResponse";
import { dev } from "@utils/dev";
import { IAdminMinerTable } from "@services/getMinerInfo";

interface IState {
  AreUnknown?: boolean;
  Miners: IAdminMinerTable[];
  UnknownMiners: IUnknownMiner[];
  Total: number;
  TabsTotals: TabsTotals;
  isRefreshing: boolean;
}

const incrementTabsTotal = (
  totals: TabsTotals,
  tab: Tab,
  delta: number
): TabsTotals => {
  const name = tabIDToType(tab);
  if (name === undefined) return totals;
  return { ...totals, [name]: totals[name] + delta };
}

const initial: IState = {
  Miners: [],
  UnknownMiners: [],
  Total: 0,
  TabsTotals: fromEntries(MinerTabsNames.map(t => [t, 0])),
  isRefreshing: false,
};

const reducer = (state = initial, action: ActionBaseStoredMiners): IState => {
  //console.log("STORED MINERS REDUCER:", state, action);
  switch (action.type) {
    case ActionTypesStoredMiners.REFRESH_MINER:
      return {
        ...state,
        Miners: state.Miners.map(miner => {
          if (miner.id === (action as ActionRefreshMiner).payload.id) {
            return (action as ActionRefreshMiner).payload;
          } else {
            return miner;
          }
        }),
      };
    case ActionTypesStoredMiners.SET_MINERS:
      const act = action as ActionSetMiners;
      const result = {
        ...state,
        Miners: act.payload.AreUnknown ? [] : act.payload.Miners as IAdminMinerTable[],
        Total: act.payload.Total === undefined ? 0 : act.payload.Total,
        TabsTotals: act.payload.AreUnknown ? state.TabsTotals : act.payload.TabsTotals, //miner/list/unknown не присылает правильные именованные тоталы
        AreUnknown: act.payload.AreUnknown,
        UnknownMiners: act.payload.AreUnknown ? act.payload.Miners as IUnknownMiner[] : [],
      };
      return result;
    case ActionTypesStoredMiners.ADD_NEW_MINER:
      const newMiner = (action as ActionAddNewMiner).payload;
      return {
        ...state,
        Miners: [newMiner, ...state.Miners],
      };
    case ActionTypesStoredMiners.ADD_NEW_MINER_LIST:
      const newMiners = (action as ActionAddNewMinerList).payload;
      return {
        ...state,
        Miners: [...newMiners, ...state.Miners],
      };
    case ActionTypesStoredMiners.CLEAR_MINERS:
      return {
        ...state,
        Miners: [],
        UnknownMiners: [],
        AreUnknown: undefined,
        Total: 0,
      };
    case ActionTypesStoredMiners.DELETE_MINER:
      const p = (action as ActionDeleteMiner).payload;
      const miners = state.Miners.filter(
        (item) => `${item.id}` !== `${p.minerID}`
      );
      return {
        ...state,
        Miners: miners,
        TabsTotals: incrementTabsTotal(state.TabsTotals, p.tab, -1),
      };
    case ActionTypesStoredMiners.SET_OPEN_MINER:
      // const openMinerAction = action as ActionSetOpenMiner;
      // let miners =
      //   state.OpenMiners?.filter((id) => id !== act.payload.id) || [];
      // if (!act.payload.reset) {
      //   miners = [...miners, act.payload.id];
      // }
      // //console.debug("SET OPEN MINERS", act.payload, miners);
      // return { ...state, OpenMiners: miners };
      return state;

    case ActionTypesStoredMiners.SET_REFRESHING:
      return {
        ...state,
        isRefreshing: true,
      };

    case ActionTypesStoredMiners.CLEAR_REFRESHING:
      return {
        ...state,
        isRefreshing: false,
      };

    default:
      return state;
  }
};

export default reducer;
